import { FC } from 'react';
import type { QualityZoneRanges } from '@/shared/lib';
import type { DashboardPresetEditor } from '../../model/useDashboardPresetEditor';
import type { CustomChartPanelFilters } from '../DashboardPresetGrid/CustomChartCard';
import { DashboardEditGrid } from './DashboardEditGrid';

type Props = {
  /** Состояние и действия режима редактирования */
  editor: DashboardPresetEditor;
  /** Фильтры панели страницы: правящийся дашборд наполняется теми же данными, что и применённый */
  filters: CustomChartPanelFilters;
  /** Пороги зон качества пользователя: диаграммы окрашены ими и в режиме правки */
  zoneRanges: QualityZoneRanges;
};

/**
 * Правка дашборда на самой странице: сетка правящегося дашборда, на которой правятся и свойства
 * каждой диаграммы. Показывается вместо дашборда — стандартного или применённого пресета.
 *
 * Своей полосы у режима нет: название правящегося дашборда, сохранение и отказ от правок стоят в
 * заголовке страницы — там, где пользователь ждёт их по прочим разделам управления.
 */
export const DashboardEditSection: FC<Props> = ({ editor, filters, zoneRanges }) => {
  const { draft } = editor;
  if (!draft) return null;

  return (
    <DashboardEditGrid
      charts={draft.charts}
      filters={filters}
      zoneRanges={zoneRanges}
      expandedChartId={editor.expandedChartId}
      onAddChart={editor.addChart}
      onToggleProperties={editor.toggleChartProperties}
      onKeepDescription={editor.keepChartDescription}
      onResolveChart={editor.applyChartValues}
      onApplyProperties={editor.applyChartProperties}
      onRemoveChart={editor.removeChart}
      onDropChart={editor.dropChart}
      onResizeChart={editor.resizeChart}
      onRestyleChart={editor.restyleChart}
      onRetemplateChart={editor.retemplateChart}
      onChangeLabelWidth={editor.setChartLabelWidth}
      onChangeTableView={editor.setChartTableView}
    />
  );
};
